import { cycles } from "./Cycles";
import COLORS from "./Colors";
import Train from "./Train";
import Simplify from "../../utils/geom/curves/Simplify";
import CatmullRom from "../../utils/geom/curves/CatmullRom";
import { distance } from "../../utils/utils";
import { getContext } from "../../utils/ImageUtils";
import Recorder from "../../utils/Recorder";

const MAX_RADIUS = 250;
const RECORD = false;
let ctx, mouse, last, stroke, nodes, edges, trains, CYCLES, NODES, ADJ;
let pat, recorder;

export default class Main {
  constructor(w, h, _ctx, _mouse) {
    ctx = _ctx;
    mouse = _mouse;
    last = { x: 0, y: 0, down: false };

    if (RECORD == true) recorder = new Recorder(ctx.canvas);

    const img = getContext(48, 48);
    img.lineWidth = 1;
    let m = 2;
    img.beginPath();
    img.moveTo(25, 24 - m);
    img.lineTo(25, 26 + m);
    img.moveTo(24 - m, 25);
    img.lineTo(26 + m, 25);
    img.stroke();
    img.fillStyle = COLORS.BG;
    img.fillRect(24, 24, 2, 2);
    // img.strokeRect(24, 24, 2, 2);

    pat = ctx.createPattern(img.canvas, "repeat");

    nodes = [];
    edges = [];
    stroke = [];
    trains = [];
    CYCLES = [];
    ADJ = [];
    NODES = [];

    mouse.on("down", this.onDown.bind(this));
    mouse.on("up", this.onUp.bind(this));
    mouse.on("move", this.onMove.bind(this));

    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    if (RECORD == true) {
      let save = document
        .querySelector(".footer")
        .querySelector(".button.save");
      save.addEventListener("pointerdown", () => {
        recorder.save("intersection-" + Date.now());
      });
    }

    let next = document.querySelector(".footer").querySelector(".button.next");
    next.addEventListener("pointerdown", () => {
      nodes = [];
      edges = [];
      CYCLES = [];
      NODES = [];
      ADJ = [];
      trains = [];
      console.log("clear");
      this.compute();
    });

    let values = [
      [382, 462, 172],
      [679, 331, 209],
      [606, 610, 180],
      [875, 438, 197],
      [461, 288, 74],
    ];
    values.forEach((v) => {
      //   this.addCircle(v[0], v[1], v[2]);
    });

    this.update();
  }

  update() {
    requestAnimationFrame(this.update.bind(this));

    ctx.fillStyle = COLORS.BG;
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    ctx.fillStyle = pat;
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    ctx.strokeStyle = "#FFF";
    ctx.lineWidth = 8;
    // this.renderGraph(ctx, { nodes, edges });

    this.hue = 0;
    ctx.lineWidth = 1;
    // CYCLES.forEach((cycle) => this.fillCycle(ctx, NODES, cycle));

    if (mouse.down) {
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.strokeStyle = "#000";
      let d = Math.min(MAX_RADIUS, distance(last, mouse));
      ctx.arc(last.x, last.y, d, 0, Math.PI * 2);
      ctx.stroke();
    }

    let t = performance.now() * 0.01;
    for (let i = 0; i < ADJ.length; i++) {
      if (ADJ[i].length > 2) {
        let ti = Math.sin(t) * 0.5 + 0.5;
        ctx.fillStyle = "#000";
        ctx.strokeStyle = "#000";
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(NODES[i].x, NODES[i].y, 1 + ti * 3, 0, Math.PI * 2);
        // ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.lineWidth = 1;

        ctx.setLineDash([3, 6]);
        // ctx.globalAlpha = 0.25;
        ADJ[i].forEach((id) => {
          ctx.moveTo(NODES[i].x, NODES[i].y);
          ctx.lineTo(NODES[id].x, NODES[id].y);
        });
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.setLineDash([]);
      }
    }

    ctx.lineWidth = 1;

    trains.sort((a, b) => {
      return a.path[0].y - b.path[0].y;
    });
    trains.forEach((train) => {
      let t = performance.now() * 0.001;
      let ti = Math.sin(t) * 0.5 + 0.5;
      train.time = (t * train.speed) % 1; //(t.time + 0.01) % 1;
      train.move(ctx);
    });
    trains.forEach((train) => {
      train.update(ctx, true);
    });
    trains.forEach((train) => {
      train.update(ctx, false);
    });
    trains.forEach((train) => {
      train.update(ctx, false, true);
    });
    if (RECORD == true) recorder.render();
  }

  addCircle(x, y, r) {
    stroke = [];
    if (r < 10) return;
    console.log(x, y, r);
    r = Math.min(r, MAX_RADIUS);
    const step = Math.PI / 8;
    for (let i = 0; i < Math.PI * 2; i += step) {
      stroke.push([x + Math.cos(i) * r, y + Math.sin(i) * r]);
    }
    this.compute();
  }
  compute() {
    // compute the cycles
    const BK_NODES = nodes.concat();
    const BK_EDGES = edges.concat();
    let result;
    try {
      // compute nodes and edges list
      let L = nodes.length;
      stroke.forEach((p, i) => {
        nodes.push(p);
        if (i > 0) {
          edges.push([L + i - 1, L + i]);
        }
      });
      edges.push([L, nodes.length - 1]); // close
      result = cycles(nodes, edges);
    } catch (e) {
      edges = BK_EDGES;
      nodes = BK_NODES;
      stroke = [];
      return;
    }
    if (result == null) {
      edges = BK_EDGES;
      nodes = BK_NODES;
      stroke = [];
      return;
    }

    //   renders the polys
    this.hue = 0;
    result.CCW.forEach((cycle) => this.fillCycle(ctx, result.nodes, cycle));

    CYCLES = result.CCW;
    NODES = result.nodes;
    ADJ = result.adjacency;

    trains = [];
    for (let i = 0; i < CYCLES.length; i++) {
      let path = [];
      CYCLES[i].forEach((id) => {
        if (nodes[id] == undefined) return;
        const p = { x: nodes[id][0], y: nodes[id][1] };
        path.push(p);
      });
      path.push(path[0]);
      if (path.length < 3) return;

      path = CatmullRom.compute(path, 0.1);
      let t = new Train(4, path);
      trains.push(t);
    }
    stroke = [];
  }

  onDown(e) {
    last.x = ~~mouse.x;
    last.y = ~~mouse.y;
    stroke.push({ x: mouse.x, y: mouse.y });
  }
  onUp(e) {
    let radius = ~~distance(last, mouse);
    this.addCircle(last.x, last.y, radius);
  }
  onMove(e) {}

  fillCycle(ctx, nodes, cycle) {
    ctx.fillStyle = `hsl(${(this.hue += 10) % 360}, 70%,50%)`;
    ctx.beginPath();
    cycle.forEach((id) => {
      ctx.lineTo(nodes[id].x, nodes[id].y);
    });
    ctx.closePath();
    ctx.fill();
  }

  strokeCycle(ctx, nodes, cycle) {
    ctx.strokeStyle = `hsl(${(this.hue += 10) % 360}, 70%,50%)`;
    ctx.beginPath();
    cycle.forEach((id, i, a) => {
      ctx.lineTo(nodes[id].x, nodes[id].y);
    });
    // ctx.closePath();
    ctx.stroke();
  }

  renderGraph(ctx, graph) {
    const N = graph.nodes;
    ctx.beginPath();
    graph.edges.forEach((e) => {
      ctx.moveTo(N[e[0]][0], N[e[0]][1]);
      ctx.lineTo(N[e[1]][0], N[e[1]][1]);
    });
    ctx.stroke();
  }
}
